import ruMessages from "devextreme/localization/messages/ru.json";
import devextremeRichEdit from "./devextremeRichEdit.locale";
export default {
    ...ruMessages.ru,
    "dxDataGrid-headerFilterOK": "Применить",
    "dxDataGrid-headerFilterCancel": "Отмена",
    OK: "Применить",
    ...devextremeRichEdit
};
